<template>
  <div class="copyProject">
    <el-dialog title="复制项目" :visible.sync="copyProjectVisible" width="650px" :show-close="true">
      <div class="content flex-column h-100">
        <div class="flex mb-10 align-center">
          <img src="/static/images/jinggao.png" class="icon-14 mr-5" alt="">
          <div class="font-12-ff5555" v-if="roomList">您正在将“{{roomList.name}}”选中的项目复制到以下房间中。请选择要复制的房间，可多选！</div>
        </div>
        <div style=" overflow-y: auto;padding-bottom: 20px;">
          <el-row :gutter="10">
            <el-col :span="8" v-for="(item, index) in tab" :key="index">
              <div @click="onSelected(item)" class="item" :class="{'active': selectedList.indexOf(item) !== -1}">{{item.name}}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-46b8b0-s mr-10" @click="onReset">重置</div>
        <div class="btn-30-bg-46b8b0-s" @click="onSubmit">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'CopyProject',
  components: {},
  props: ['tab', 'roomList'],
  data () {
    return {
      copyProjectVisible: false,
      // list: ['客厅', '餐厅', '厨房', '主卧', '侧卧', '客房', '阳台'],
      selectedList: []
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onSelected (item) {
      if (this.selectedList.indexOf(item) !== -1) {
        this.selectedList.splice(this.selectedList.indexOf(item), 1)
      } else {
        this.selectedList.push(item)
      }
    },
    onReset () {
      this.selectedList = []
    },
    onSubmit () {
      this.copyProjectVisible = false
      this.$emit('copy-project', this.selectedList)
      this.selectedList = []
    }
  }
}
</script>

<style lang="scss" scoped>
  .content{
    padding: 10px 20px;
    /*height: 360px;*/
  }
  .copyProject /deep/ .el-dialog{
    /*height: 400px;*/
    display: flex;
    flex-direction: column;
  }
  .copyProject /deep/ .el-dialog__body{
    flex: 1;
  }
  .button{
    border: solid 1px #e2e2e2;
    border-radius: 4px;
    cursor: pointer;
  }
  .item{
    margin-bottom: 10px;
    background-color: #f3f4f7;
    border-radius: 4px;
    border: solid 1px #e2e2e2;
    height: 24px;
    line-height: 24px;
    color: #30313a;
    cursor: pointer;
  }
  .active{
    color: #46b8b0;
    border-color: #46b8b0;
    background: #fef0dd;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/enterRoomItem/CopyProject.vue